// extracted by mini-css-extract-plugin
export default {"container":"_2CW8","content":"_1OpB","chat":"_2Td7"};